import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import history from '../../../../route/history'
import { alertActions, certmngActions } from '../../../../store/actions'
import { commons } from '../../../../hook/common'

const CertMngDetail = (props) => {
  const queryString = require('query-string')
  const [state, setState] = useState({})
  const [historyInfo, setHistoryInfo] = useState({})
  const [certmngInfo, setCertmngInfo] = useState({})

  useEffect(() => {
    const locationInfo = props.location.state

    locationInfo &&
      setHistoryInfo({
        ...historyInfo,
        crtfIssuInstCd: locationInfo?.crtfIssuInstCd,
        srhKeyword: locationInfo?.srhKeyword,
        pageIdx: locationInfo?.pageIdx || 0,
      })

    if (props.match.params.seq) {
      let crtfCd = props.match.params.seq
      props.getCertmngInfo(crtfCd)
    }
  }, [])

  const goList = () => {
    let paramStr = queryString.stringify(historyInfo)
    paramStr.length > 0 && (paramStr = '?' + paramStr)
    history.push('/service/certmng' + paramStr)
  }

  const goApply = (crtfCd) => {
    if (crtfCd === '01') {
      history.push('/service/certapply/1')
    }
  }

  useEffect(() => {
    if (props.certmngInfo) {
      setCertmngInfo(props.certmngInfo)
    } else {
    }
  }, [props.certmngInfo])

  return (
    <>
      {/* contents */}
      <div id="contents">
        <div className="content-header">
          <h2>증명서 신청</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>증명서 신청</span>
            <em>증명서 신청</em>
          </div>
        </div>
        <div className="detail-info">
          <div className="row">
            <p className="txt">
              <span>발급기관</span>
              {props.certmngInfo?.crtfIssuInstNm}
            </p>
            <p className="tit">{props.certmngInfo?.crtfNm}</p>
          </div>
        </div>
        <table className="tbl-view">
          <caption>서비스명, 서비스 개요, 신청 방법, 처리 기간, 수수료, 신청 대상, 소관 기관 항목으로 구성</caption>
          <colgroup>
            <col className="col1" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">서비스명</th>
              <td>{props.certmngInfo?.crtfNm}</td>
            </tr>
            <tr>
              <th scope="row">서비스 개요</th>
              <td>{props.certmngInfo?.crtfSumryCn}</td>
            </tr>
            <tr>
              <th scope="row">신청 방법</th>
              <td>인터넷</td>
            </tr>
            <tr>
              <th scope="row">처리 기간</th>
              <td>{props.certmngInfo?.crtfProprodCn}</td>
            </tr>
            <tr>
              <th scope="row">수수료</th>
              <td>
                {props.certmngInfo?.crtfFeeAmt && commons.addComma(props.certmngInfo?.crtfFeeAmt) + '원 (발급기관 결제) (부가세포함)'}
              </td>
            </tr>
            <tr>
              <th scope="row">신청 대상</th>
              <td>{props.certmngInfo?.crtfAplyTrgtNm}</td>
            </tr>
            <tr>
              <th scope="row">소관 기관</th>
              <td>{props.certmngInfo?.crtfIssuInstNm}</td>
            </tr>
          </tbody>
        </table>
        <div className="btn-block center">
          {props.certmngInfo?.applyYn === 'Y' && (
            <a href="#" className="btn-primary lg w200" onClick={() => goApply(props.certmngInfo?.crtfCd)}>
              신청하기
            </a>
          )}
          <a href="#" className="btn-secondary lg w200" onClick={goList}>
            목록
          </a>
        </div>
      </div>
      {/* //contents */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    certmngInfo: state.certmng?.certmngInfo,
  }
}

const actionCreators = {
  getCertmngInfo: certmngActions.getCertmngInfo,
  success: alertActions.success,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(CertMngDetail)
